module.exports = __webpack_public_path__ + "static/media/img-contact.571bb83b.jpg";